
      export default {
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-282 405.9 30 30"}},[_c('path',{attrs:{"d":"M-260 420.9c-1 0-3 2-7 2s-6-2-7-2c-1.1 0-2 .9-2 2 0 1 .6 1.5 1 1.7 1.2.7 5 2.3 5 2.3l-4.2 5.4s-.8.9-.8 1.6c0 1.1.9 2 2 2 1 0 1.5-.7 1.5-.7s4.5-5.4 4.5-5.3l4.5 5.3s.5.7 1.5.7c1.1 0 2-.9 2-2 0-.6-.8-1.6-.8-1.6l-4.2-5.4s3.8-1.6 5-2.3c.4-.3 1-.7 1-1.7 0-1.1-.9-2-2-2zm-7-15c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm0 10.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"}})])
      }
    
      }
    